export interface LanderConfig {
  id: string;
  slug: string;
  eyebrow: string;
  headline: string;
  subheadline: string;
  cta: string;
  accent: string;
}

export const landers: Record<string, LanderConfig> = {
  "make-money": {
    id: "make-money-v1",
    slug: "make-money",
    eyebrow: "EARN EXTRA CASH ONLINE",
    headline: "Turn spare time into extra cash.",
    subheadline: "Complete simple online offers and keep track of everything you earn from one Bucks account.",
    cta: "Start earning",
    accent: "mint",
  },
  "get-paid": {
    id: "first-five-v1",
    slug: "get-paid",
    eyebrow: "YOUR FIRST GOAL",
    headline: "Your first $5 starts here.",
    subheadline: "Choose simple earning opportunities and watch your balance grow toward your first goal.",
    cta: "Start my $5 goal",
    accent: "gold",
  },
  "earn-extra-cash": {
    id: "fastest-path-v1",
    slug: "earn-extra-cash",
    eyebrow: "A CLEAR NEXT STEP",
    headline: "Find your fastest path to extra cash.",
    subheadline: "Bucks shows which available opportunity moves you closest to your next earning goal.",
    cta: "Show me how to earn",
    accent: "blue",
  },
  "paid-surveys": {
    id: "surveys-v1",
    slug: "paid-surveys",
    eyebrow: "SIMPLE ONLINE OPPORTUNITIES",
    headline: "Get rewarded for simple things you do online.",
    subheadline: "Complete surveys, signups, quotes, and other opportunities and track rewards in one place.",
    cta: "Start earning",
    accent: "coral",
  },
};

export const defaultLander = landers["make-money"];
